import { render, staticRenderFns } from "./CallsList.vue?vue&type=template&id=eeceb18c"
import script from "./CallsList.vue?vue&type=script&lang=js"
export * from "./CallsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports